import React from 'react';
import { Space } from 'antd';
import EditCatalogLabTestButton from './EditCatalogLabTestButton';

const ActionsColumn = ({ columnData, onUpdateLabTest, getCatalogSurgeryInfo }) => (
  <Space>
    <EditCatalogLabTestButton
      columnData={columnData}
      onUpdateLabTest={onUpdateLabTest}
      getCatalogSurgeryInfo={getCatalogSurgeryInfo}
    />
  </Space>
);
export default ActionsColumn;
